import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import BookingDialog from "@/components/site/BookingDialog";
import Reveal from "@/components/site/Reveal";

export default function AboutPage() {
  const [bookingOpen, setBookingOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#FAF7F8] text-[#1E1E2A]" data-testid="about-page">
      <Navbar onBookingClick={() => setBookingOpen(true)} />
      <main className="pt-32 pb-24 md:pt-40 md:pb-32">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link
            to="/"
            data-testid="back-home-link"
            className="inline-flex items-center gap-2 text-sm text-[#5F6170] hover:text-[#2847B8] transition-colors mb-12"
          >
            <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
          </Link>

          <Reveal>
            <span className="text-sm uppercase tracking-[0.2em] text-[#C98FA3] font-medium">
              À propos
            </span>
            <h1 className="font-serif-display text-5xl md:text-6xl font-light mt-4 mb-10 leading-[1.05]">
              Francine Banzadio
            </h1>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="space-y-6 text-lg leading-relaxed text-[#5F6170]">
              <p>
                Après un parcours scientifique et analytique, je me suis orientée vers l'accompagnement
                des personnes. Une trajectoire qui m'a appris à conjuguer rigueur d'analyse et présence
                humaine.
              </p>
              <p>
                Formée à la sophro-analyse des mémoires prénatales, de la naissance et de l'enfance,
                ainsi qu'aux constellations familiales et systémiques, j'accompagne depuis plus de
                15 ans des personnes confrontées à des blocages émotionnels et à des schémas répétitifs.
              </p>
              <p>
                Mon travail consiste à révéler les dynamiques invisibles qui se rejouent dans une vie,
                qu'elles trouvent leur origine dans l'enfance, dans le vécu émotionnel ou dans une
                histoire familiale plus large. Cette exploration se déploie dans un cadre posé, progressif
                et respectueux du rythme de chacun.
              </p>
              <p>
                Plus de 800 personnes ont déjà été accompagnées en individuel et en groupe, en présentiel
                comme à distance.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="mt-16 p-10 md:p-12 rounded-3xl bg-[#F3EEF4] border border-[#DDD7E2]">
              <h2 className="font-serif-display text-3xl md:text-4xl font-light mb-4">
                Formation & approche
              </h2>
              <ul className="space-y-3 text-[#5F6170] mt-6">
                <li>— Sophro-analyse des mémoires prénatales, de la naissance et de l'enfance</li>
                <li>— Constellations familiales et systémiques</li>
                <li>— Travail sur les psychotraumas et schémas émotionnels</li>
                <li>— Accompagnement individuel et animation de groupes</li>
                <li>— Plus de 15 ans d'expérience clinique</li>
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.3}>
            <div className="mt-16 flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => setBookingOpen(true)}
                data-testid="about-book-btn"
                className="bg-[#2847B8] text-white hover:bg-[#3A2E6E] transition-all duration-300 rounded-full px-8 py-4 font-medium"
              >
                Prendre rendez-vous
              </button>
              <Link
                to="/#services"
                data-testid="about-services-link"
                className="border-2 border-[#C98FA3] text-[#1E1E2A] hover:bg-[#C98FA3] hover:text-white transition-all duration-300 rounded-full px-8 py-4 font-medium text-center"
              >
                Découvrir les accompagnements
              </Link>
            </div>
          </Reveal>
        </div>
      </main>
      <Footer />
      <BookingDialog open={bookingOpen} onOpenChange={setBookingOpen} />
    </div>
  );
}
